/* global System */
// register component(s) with react habitat

export default { Header: () => System.import('./index') }
